(function () {
  const attr = {
    trigger: 'data-quick-view-trigger',
    productUrl: 'data-quick-view-product-url',
    content: 'data-quick-view-content',
    spinner: 'data-quick-view-spinner',
    closeBtn: 'data-quick-view-close-btn',
    closeBtnSlot: 'data-quick-view-close-btn-slot',
  };

  if (customElements.get('quick-view')) return;

  customElements.define(
    'quick-view',
    class extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('#quick-view-dialog');
        this.contentContainer = this.querySelector(`[${attr.content}]`);
        this.spinnerTemplate = this.querySelector(`[${attr.spinner}]`);
        this.closeBtnTemplate = this.querySelector(`[${attr.closeBtn}]`);
        this.abortController = null;
        this.handleTriggerClick = this.handleTriggerClick.bind(this);
      }

      connectedCallback() {
        document.addEventListener('click', this.handleTriggerClick);
        document.addEventListener('liquid-ajax-cart:request-end', this.handleCartRequestEnd.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleTriggerClick);
        document.removeEventListener('liquid-ajax-cart:request-end', this.handleCartRequestEnd.bind(this));
        this.abortController?.abort();
      }

      handleCartRequestEnd(event) {
        const { requestState } = event.detail;
        if (requestState.requestType === 'add' && requestState.responseData?.ok) {
          this.dialog.close();
        }
      }

      handleTriggerClick(event) {
        const trigger = event.target.closest(`[${attr.trigger}]`);
        if (!trigger) return;

        event.preventDefault();
        const productUrl = trigger.getAttribute(attr.productUrl);
        if (productUrl) {
          this.openQuickView(productUrl);
        }
      }

      async openQuickView(productUrl) {
        this.showLoading();
        this.dialog.showModal();

        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('section_id', 'quick-view-product-v2025');
          const sectionUrl = url.toString();
          const response = await fetch(sectionUrl, {
            signal: this.abortController.signal,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const html = await response.text();
          this.contentContainer.innerHTML = html;
          this.injectCloseButton();
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error('Quick view fetch error:', error);
          this.showError();
        }
      }

      injectCloseButton() {
        const slot = this.contentContainer.querySelector(`[${attr.closeBtnSlot}]`);
        if (slot && this.closeBtnTemplate) {
          slot.replaceWith(this.closeBtnTemplate.content.cloneNode(true));
        }
      }

      showLoading() {
        const spinnerHtml = this.spinnerTemplate?.innerHTML || '';
        this.contentContainer.innerHTML = `
          <div class="tw:flex tw:items-center tw:justify-center tw:py-20">
            <span class="tw:size-10 tw:animate-spin">${spinnerHtml}</span>
          </div>
        `;
      }

      showError() {
        this.contentContainer.innerHTML = `
          <div class="tw:text-center tw:py-10 tw:text-body">
            Unable to load product. Please try again.
          </div>
        `;
      }
    }
  );
})();
